import { throwErrorWithStack } from "../crashlytics";
// import { GoogleGameServices } from "../plugins";
import { IS_WEB, ACHIEVEMENTS_ENABLED } from "../config";
import { getLogger } from "../logging";

const log = getLogger("🏆 Achievements");

const DISABLED = IS_WEB || !ACHIEVEMENTS_ENABLED;

export const ACHIEVEMENT_IDS = {
  pro: "CgkI34Sxls8KEAIQAw",
  power_user: "CgkI34Sxls8KEAIQFw",
  full: "CgkI34Sxls8KEAIQGQ",
  kitten: "CgkI34Sxls8KEAIQEQ",
  junior: "CgkI34Sxls8KEAIQEg",
  senior: "CgkI34Sxls8KEAIQEw",
  prime: "CgkI34Sxls8KEAIQFA",
  hero: "CgkI34Sxls8KEAIQGA",
  demigod: "CgkI34Sxls8KEAIQFQ",
  god: "CgkI34Sxls8KEAIQFg",
};

export const getAchievementByLevel = (levelIdx) => {
  const achievement_name = {
    0: "kitten",
    3: "junior",
    5: "senior",
    7: "prime",
    9: "hero",
    10: "demigod",
    11: "god",
  }[levelIdx];
  return achievement_name && ACHIEVEMENT_IDS[achievement_name];
};

export async function incrementPowerUserCount() {
  __DEV__ && log.debug("Achievement Increment Power");
  if (DISABLED) return;
  try {
    const achievementId = ACHIEVEMENT_IDS.power_user;
    await GoogleGameServices.incrementAchievement({
      achievementId,
    });
  } catch (error) {
    throwErrorWithStack(error);
  }
}

export async function unlockAchievement(levelIdx) {
  __DEV__ && log.debug("Unlock Achievement", levelIdx);
  if (DISABLED) return;
  try {
    const achievementId = getAchievementByLevel(levelIdx);
    if (achievementId)
      await GoogleGameServices.unlockAchievement({
        achievementId,
      });
  } catch (error) {
    throwErrorWithStack(error);
  }
}

export const unlockAllAchievements = async (maxLevelIdx) => {
  try {
    await Promise.all([...Array(maxLevelIdx).keys()].map(unlockAchievement));
  } catch (error) {
    throwErrorWithStack(error);
  }
};

export async function openAchievementsCb(e) {
  e.stopImmediatePropagation();
  if (DISABLED) return;
  try {
    await GoogleGameServices.showAchievements();
  } catch (error) {
    try {
      const ret1 = await GoogleGameServices.isAuthenticated();
      let isAuthenticated = ret1.isAuthenticated;
      if (!isAuthenticated) {
        const ret2 = await GoogleGameServices.signIn();
        isAuthenticated = ret2.isAuthenticated;
      }
      if (isAuthenticated) openAchievementsCb(e);
      else showToast("Please sign in with Play Games");
    } catch (error) {
      throwErrorWithStack(error);
    }
  }
  return false;
}

export async function unlockAchievementByName(name) {
  __DEV__ && log.debug("Unlock Achievement", name);
  if (DISABLED) return;
  try {
    const achievementId = ACHIEVEMENT_IDS[name];
    if (achievementId)
      await GoogleGameServices.unlockAchievement({
        achievementId,
      });
  } catch (error) {
    throwErrorWithStack(error);
  }
}
